export default __webpack_public_path__ + "corel-videostudio.f3b78a43.png";